module.exports = __webpack_public_path__ + "fonts/Samba.46ae87d4.ttf";